/** The past-date rule a reschedule picker states up front, so the server's refusal is never a surprise. */
import { VISIT_PAST_RETENTION_DAYS } from '@jms/model';
import { DateTime } from 'luxon';

/** "A past date must be on or after the visit's original date, and no earlier than 16 Aug 2026." in the Visit's zone. */
export function visitRescheduleRuleText(now: Date, timezone?: string): string {

  const cutoff = DateTime.fromJSDate(now, { zone: timezone }).startOf('day').minus({ days: VISIT_PAST_RETENTION_DAYS }).toFormat('d LLL yyyy');
  return `A past date must be on or after the visit's original date, and no earlier than ${cutoff}.`;
}
